var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 11.25C1.77554 11.25 1.68016 11.2105 1.60984 11.1402C1.53951 11.0698 1.5 10.9745 1.5 10.875V1.5968C1.50003 1.49854 1.52579 1.40201 1.57472 1.31681C1.62366 1.23161 1.69405 1.16071 1.77891 1.11117C2.0625 0.946406 2.63391 0.75 3.75 0.75C4.62211 0.75 5.59758 1.09477 6.4582 1.39875C7.15125 1.64367 7.80586 1.875 8.25 1.875C8.82174 1.87325 9.38742 1.75772 9.91406 1.53516C9.97819 1.50809 10.048 1.4973 10.1173 1.50377C10.1867 1.51025 10.2533 1.53377 10.3113 1.57224C10.3693 1.61071 10.4169 1.66295 10.4498 1.72428C10.4828 1.78561 10.5 1.85414 10.5 1.92375V7.065C10.4999 7.15613 10.4733 7.24525 10.4233 7.32147C10.3734 7.39769 10.3023 7.45769 10.2188 7.49414C10.0146 7.58344 9.2693 7.875 8.25 7.875C7.68422 7.875 6.97547 7.70766 6.22523 7.53023C5.38195 7.33102 4.51008 7.125 3.75 7.125C2.88586 7.125 2.44359 7.25578 2.25 7.33852V10.875C2.25 10.9745 2.21049 11.0698 2.14016 11.1402C2.06984 11.2105 1.97446 11.25 1.875 11.25Z",
    fill: "#20E290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGreen);
export default __webpack_public_path__ + "static/media/flag_green.5e69d6fc6bd1e152653c9f29108d3db5.svg";
export { ForwardRef as ReactComponent };